<template>
  <div class="legal-entities">
    <div class="flex space-between">
      <h1 class="legal-entities__title">Юридические лица <span v-if="total" class="legal-entities__count">{{total}}</span> </h1>
      <VButtonNew  @click="add" class="legal-entities__create" label="Новое юридическое лицо" style-type="link">
        <template #iconLeft>
          <IconsPlus icon-size="20px" />
        </template>
      </VButtonNew>
    </div>
    <div class="legal-entities__wrapper">
      <main class="legal-entities__main">
        <h2 class="legal-entities__main-title">
          Список юридических лиц
        </h2>
        <p class="legal-entities__main-description">
          Вы можете добавлять, редактировть и удалять юридические лица
        </p>
        <div class="legal-entities__main-list legal-entities__list">
          <SettingsReasonElement
              v-if="!skeleton"
              v-for="(item, index) in currentReasons"
              :key="item.id"
              :data="item"
              @edit="onEdit"
              @delete="openModalDelete"
          />
          <div v-if="skeleton" class="setting__block-option">
            <VSkeleton class="setting__block-option-block" variants="SETTINGS_REASONS" v-if="skeleton"/>
          </div>
        </div>
        <div class="legal-entities__no-content" v-if="!skeleton && !currentReasons?.length">
          <VNoContent
              title="Список юридических лиц пуст"
          />
        </div>
<!--        <button class="legal-entities__main-button" @click="addReason">-->
<!--          <IconsPlus />-->
<!--          <span class="legal-entities__main-button-text"-->
<!--          >Добавить причину</span-->
<!--          >-->
<!--        </button>-->
      </main>
    </div>
    <ModalWindow
        class="legal-entities__modal-poups"
        :showModalWithOverflow="showModalWindow"
        v-show="showModalWindow"
        @close="close"
    >
      <VModalWrapper
          :ok-btn-title="dataForm.id ? 'Сохранить': 'Добавить'"
          :title="dataForm.id ? 'Редактировать юридическое лицо' : 'Новое юридическое лицо'"
          width="477px"
          @close="close"
          @apply="apply"
      >
        <VCustomInput
            class="legal-entities__input"
            placeholder="Краткое наименование*"
            :error="v$.short_name.$error"
            v-model="dataForm.short_name"
        />
          <p class="legal-entities__form-field-error" v-if="v$.short_name.$error">
            Заполните обязательное поле
          </p>
        <VCustomInput
            class="legal-entities__input"
            placeholder="Полное наименование"
            v-model="dataForm.name"
        />
        <VCustomInput
            class="legal-entities__input"
            placeholder="ИНН"
            v-mask="'0000-00000-0'"
            v-model="dataForm.inn"
        />
        <VCustomInput
            class="legal-entities__input"
            placeholder="КПП"
            v-mask="'0000-00-000'"
            v-model="dataForm.kpp"
        />
        <VCustomInput
            class="legal-entities__input"
            placeholder="ОГРН"
            v-mask="'0-00-00-0000000-0'"
            v-model="dataForm.ogrn"
        />
      </VModalWrapper>
    </ModalWindow>
    <ModalWindow
        class="legal-entities__modal-delete"
        :showModalWithOverflow="showModalDelete"
        v-show="showModalDelete"
        @close="showModalDelete = false"
    >
      <DeleteItems
          title="Удалить юр лицо"
          :deleteIntegrationsName="deleteItem?.short_name"
          @close="showModalDelete = false"
          @delete="onDeleteReason"
      />
    </ModalWindow>
  </div>
</template>

<script setup>
import {ref, computed, onMounted} from "vue";
import SettingsReasonElement from "@/components/Settings/SettingsReasonElement";
import VSkeleton from "@/components/UI/VSkeleton/index.vue";
import IconsPlus from "@/components/Icons/Plus.vue";
import VButtonNew from "@/components/UI/VButtonNew/index.vue";
import VModalWrapper from "@/components/UI/VModalWrapper.vue";
import DeleteItems from "@/components/ModalWindow/ModalBodyes/DeleteItems.vue";
const skeleton = ref(true)
const dataItems = ref([]);
import legal from "@/api/legal";
import { required } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import useOffsetTop from "@/hooks/getOffsetTopScroll";

const rules = computed(() => ({
  short_name: { required },
}));

const dataForm = ref({
  short_name: "",
  full_name: "",
  inn: "",
  kpp: "",
  ogrn: ""
})

const v$ = useVuelidate(rules, dataForm);

const showModalDelete = ref(false);
const showModalWindow = ref(false);
const total = ref(0);
const currentReasons = computed(
    () => dataItems.value?.data
);
const add = () => {
  v$.value.$reset()
  dataForm.value = {
    id: "",
    short_name: "",
    name: "",
    inn: "",
    kpp: "",
    ogrn: ""
  }
  showModalWindow.value = true;
};

const apply = async () => {
  const args = {
    id: dataForm.value?.id,
    short_name: dataForm.value?.short_name,
    name: dataForm.value?.name,
    inn: dataForm.value?.inn?.replace(/-/g, ""),
    kpp: dataForm.value?.kpp?.replace(/-/g, ""),
    ogrn: dataForm.value?.ogrn?.replace(/-/g, "")
  }

  const validate = await v$.value.$validate();
  if (!validate) {
    useOffsetTop();
    return;
  }

  if(args?.id) {
    await legal.editLegal(args, args?.id)
  } else {
    await legal.addLegal(args)
  }
  await getRejectionLegal();
  showModalWindow.value = false;
}

const onEdit = (item) => {
  v$.value.$reset()
  dataForm.value = {...item};
  showModalWindow.value = true;
};

const close = () => {
  showModalWindow.value = false
}

const deleteItem = ref(null)
const openModalDelete = (item) => {
  deleteItem.value = item;
  showModalDelete.value = true;
}

const onDeleteReason = async () => {
  await legal.deleteLegal(deleteItem.value.id)
  showModalDelete.value = false;
  await getRejectionLegal();
};

const getRejectionLegal = async () => {
  dataItems.value = await legal.getLegal()
  total.value = dataItems.value?.meta?.count || 0
  skeleton.value = false;
};
onMounted(async () => {
  await getRejectionLegal();
})
</script>

<style scoped lang="scss">
.legal-entities {
  width: 832px;

  &__no-content {
    width: 100%;
    height: calc(100vh - 743px);
    display: flex;
    justify-content: center;
    align-items: center;
    :deep(.v-no-content) {
      margin-top: 0!important;
    }
  }

  &__create {
    margin-top: 16px;
    font-weight: 500;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0;
    text-align: right;

  }

  &__title {
    margin-top: 28px;
    margin-bottom: 24px;
    font-weight: 700;
    font-size: 28px;
    line-height: 33.89px;
    letter-spacing: 0%;
    color: $dark;
  }

  &__count {
    font-weight: 700;
    font-size: 16px;
    color: $gray;
    line-height: 100%;
    letter-spacing: 0;
  }

  &__wrapper {
    display: flex;
    column-gap: 32px;
    align-items: flex-start;
  }
  &__aside {
    padding: 12px;
    width: 256px;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    border-radius: 16px;
    flex-grow: 0;
  }
  &__aside-title {
    width: 232px;
    margin-top: 12px;
    margin-bottom: 12px;
    margin-left: 12px;
    font-weight: 600;
    font-size: 16px;
    line-height: 19.36px;
    letter-spacing: 0%;
    color: $dark;
  }
  &__aside-item {
    width: 232px;
    padding: 12px;
    font-weight: 400;
    font-size: 14px;
    line-height: 16.94px;
    letter-spacing: 0%;
    color: $dark;
    border-radius: 8px;
    cursor: pointer;

    &:not(:last-child) {
      margin-bottom: 4px;
    }
    &:hover {
      background-color: #f0f2f4;
    }

    &_active {
      background-color: #f0f2f4;
    }
  }
  &__main {
    width: 832px;
    padding: 24px;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    border-radius: 16px;
  }
  &__main-title {
    margin-bottom: 8px;
    font-weight: 500;
    font-size: 20px;
    line-height: 24.2px;
    letter-spacing: 0%;
    color: $dark;
  }
  &__main-description {
    max-width: 528px;
    margin-bottom: 16px;
    font-weight: 400;
    font-size: 14px;
    line-height: 16.94px;
    letter-spacing: 0%;

    color: $gray;
  }
  &__main-button {
    padding: 4px;
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: flex-start;
    background-color: transparent;
    margin-right: auto;
    outline: none;
    border: none;
    color: $blue;
    font-weight: 400;
    font-size: 14px;
    line-height: 16.94px;
    letter-spacing: 0%;
    text-align: right;
    cursor: pointer;
  }
  &__main-button-icon {
    margin-right: 4px;
  }
  &__list {
    padding-top: 16px;
    border-top: 1px solid $light-gray-1;
  }
  &__item {
    display: flex;
    position: relative;
    width: 100%;
    column-gap: 16px;

    &:not(:last-child) {
      margin-bottom: 12px;
    }
  }
  &__item-content {
    padding: 15.5px 16px;
    background-color: #f4f5f7;
    border-radius: 8px;
    font-weight: 400;
    font-size: 14px;
    line-height: 16.94px;
    letter-spacing: 0%;
    flex: 1 1 calc(100% - 16px - 24px);
  }
  &__item-actions {
    width: 24px;
    height: 24px;
    flex: 1 1 24px;
    cursor: pointer;
  }

  &__item-actions-icon {
    display: block;
    margin-top: 12px;
  }
  &__actions-dropdown {
    position: absolute;
    right: 0px;
    bottom: -72px;
    z-index: +5;
    padding: 8px 12px;
    width: 174px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 2px 4px 24px 0px rgba(0, 0, 0, 0.12);
  }
  &__action-edit {
    display: flex;
    align-items: center;
    height: 32px;
    margin-bottom: 8px;
    column-gap: 4px;
    cursor: pointer;
  }
  &__action-delete {
    display: flex;
    align-items: center;
    height: 32px;
    column-gap: 4px;
    cursor: pointer;
  }
  &__modal-delete {
    &::v-deep(.modal__body) {
      width: 360px;
      height: auto;
      border-radius: 16px;
    }
  }
  &__modal-poups {
    &::v-deep(.modal__body) {
      width: auto;
      height: auto;
      border-radius: 16px;
    }
  }
  &__input {
    width: 100%;
  }
  &__form-field-error {
    margin-top: -4px;
    font-size: 14px;
    color: $red;
  }
}
</style>
